import { useEffect } from 'react';
import { API_URL } from '../services/api';

/**
 * Hook to maintain user's online presence
 * 
 * NOTE: Heartbeat is now handled by useWebSocket.js
 * This hook only handles page close/visibility events
 */
export const usePresence = () => {
  useEffect(() => {
    // Handle page visibility changes - WebSocket reconnects automatically
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // WebSocket will auto-reconnect and send heartbeat
      }
    };

    // Handle before unload - notify server of disconnect
    const handleBeforeUnload = () => {
      // Use sendBeacon for reliable delivery on page close
      const url = `${API_URL}/presence/offline`;
      navigator.sendBeacon(url);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
};

export default usePresence;
